<template>
  <div>
    <v-dialog
      v-model="dlg"
      fullscreen
      overlay-color="black"
      overlay-opacity="1"
      :light="false"
      transition="dialog-bottom-transition"
    >
      <v-sheet class="loader-sheet" :height="actualDevHeight + 'px'">
        <!-- <v-img  src="../../../assets/food_loader_new.gif" :aspect-ratio="16 / 28"> </v-img> -->
        <v-overlay :model-value="dlg" class="align-center justify-center">
          <v-progress-circular
            color="primary"
            indeterminate
            size="64"
          ></v-progress-circular>
        </v-overlay>
      </v-sheet>
    </v-dialog>
    <!-- <v-dialog v-model="dlg">
      <v-img
        :aspect-ratio="16 / 28"
        src="../../../assets/food_loader_new.gif"
      />
    </v-dialog> -->
  </div>
</template>

<script>
export default {
  data: () => ({
    dlg: true,
  }),
};
</script>

<style scoped>
/* .load-bg {
  height: 100%;
  display: flex;
  background: rgba(0, 0, 0, 0.5294117647058824);
} */
/* show the overlay after 1s */

/* .overlay-delay {
  -webkit-animation-name: showlater;
  animation-name: showlater;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-timing-function: ease-in;
  animation-timing-function: ease-in;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
} */
/* @keyframes showlater {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 100;
  }
} */
/* @keyframes bounce-anim {
  0% {
    animation-timing-function: cubic-bezier(0.138, 0.2541, 0.2177, 0.8747);
    transform: translate(0, 0) scaleY(1);
  }
  37% {
    animation-timing-function: cubic-bezier(0.7679, 0.1817, 0.8401, 0.7167);
    transform: translate(0, -39.96px) scaleY(1);
  }
  72.2% {
    animation-timing-function: cubic-bezier(0.1045, 0.2026, 0.2224, 0.9608);
    transform: translate(0, 0) scaleY(1);
  }
  87.2% {
    animation-timing-function: cubic-bezier(0.7463, 0.2314, 0.8159, 0.6941);
    transform: translate(0, 19.85px) scaleY(0.603);
  }
  100% {
    transform: translate(0, 0) scaleY(1);
  }
} */

/* .bounce-2 {
  animation: bounce-anim 1s infinite linear;
}
.bounce-pig {
  animation: bounce-anim 1.5s infinite linear;
} */
</style>
<style>
.loader-sheet{
  /* background: unset !important; */
}
</style>